import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';


@Directive({
    selector: '[appJsonValidator]',
    providers: [{provide: NG_VALIDATORS, useExisting: JsonValidatorDirective, multi: true}]
})

/**
 * This directive provides a custom validator to check if a JSON string passed from a form
 * can be parsed to a JavaScript Object.  If null is returned, the validation has effectively passed,
 * if a error object is returned the validation has failed.
 */
export class JsonValidatorDirective {

    validate(control: AbstractControl) {
        let formJson = control.value;
        // Check if the form value passed to the validator is undefined - we don't need to validate
        // an empty form value.
        if (!formJson) { return null; }

        try {
            JSON.parse(formJson);
            return null;
        } catch (ex) {
            return {JsonValidator: 'Unable to parse supplied string to JSON'};
        }
    }
}
